/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType } from "./http-client";
export class Properties {
  http;
  constructor(http) {
    this.http = http;
  }
  /**
   * @description Retrieve all properties belonging to the current organization.
   *
   * @tags Properties
   * @name GetProperties
   * @summary List Properties
   * @request GET:/api/properties
   * @secure
   */
  getProperties = (params = {}) =>
    this.http.request({
      path: `/api/properties`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Register a new real estate property in the organization's portfolio. Requires Manager or Owner role.
   *
   * @tags Properties
   * @name CreateProperty
   * @summary Create Property
   * @request POST:/api/properties
   * @secure
   */
  createProperty = (data, params = {}) =>
    this.http.request({
      path: `/api/properties`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve detailed information about a specific property by its ID.
   *
   * @tags Properties
   * @name GetProperty
   * @summary Get Property
   * @request GET:/api/properties/{property_id}
   * @secure
   */
  getProperty = (propertyId, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update the details of an existing property. Requires Manager or Owner role.
   *
   * @tags Properties
   * @name UpdateProperty
   * @summary Update Property
   * @request PUT:/api/properties/{property_id}
   * @secure
   */
  updateProperty = (propertyId, data, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Partially update a property. Only provided fields are changed. Include updatedAt for optimistic locking.
   *
   * @tags Properties
   * @name PatchProperty
   * @summary Partial Update Property
   * @request PATCH:/api/properties/{property_id}
   * @secure
   */
  patchProperty = (propertyId, data, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Permanently remove a property from the portfolio. Requires Manager or Owner role.
   *
   * @tags Properties
   * @name DeleteProperty
   * @summary Delete Property
   * @request DELETE:/api/properties/{property_id}
   * @secure
   */
  deleteProperty = (propertyId, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Update the availability status of a property.
   *
   * @tags Properties
   * @name UpdatePropertyStatus
   * @summary Update Property Status
   * @request PUT:/api/properties/{property_id}/status
   * @secure
   */
  updatePropertyStatus = (propertyId, query, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}/status`,
      method: "PUT",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Evaluate property readiness across photos, pricing, amenities, access info, and document completeness. Requires Manager or Owner role.
   *
   * @tags Properties
   * @name GetPropertyReadiness
   * @summary Get Property Readiness Inspection
   * @request GET:/api/properties/{property_id}/readiness
   * @secure
   */
  getPropertyReadiness = (propertyId, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}/readiness`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Atomically complete the Add-Property wizard: validates the draft (photos + live listing), publishes the reviewed listing, makes the property AVAILABLE and clears the wizard marker — all in one transaction. Safe to retry.
   *
   * @tags Properties
   * @name FinishPropertySetup
   * @summary Finish Property Setup
   * @request POST:/api/properties/{property_id}/finish-setup
   * @secure
   */
  finishPropertySetup = (propertyId, data, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}/finish-setup`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get share URL and QR code for a property.
   *
   * @tags Properties
   * @name GetShareInfo
   * @summary Get Property Share Info
   * @request GET:/api/properties/{property_id}/share
   * @secure
   */
  getShareInfo = (propertyId, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}/share`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Mint the token the editor passes to the marketing-site iframe so it can render this property's public page before it is published. The token is bound to this organization and this property and expires in minutes; it carries no user identity and authorizes reads only. Access is checked the same way reading the property is — org-scoped lookup.
   *
   * @tags Properties
   * @name MintPropertyPreviewToken
   * @summary Mint a short-lived property-preview token
   * @request POST:/api/properties/{property_id}/property-preview-token
   * @secure
   */
  mintPropertyPreviewToken = (propertyId, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}/property-preview-token`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve the stored address details for a property.
   *
   * @tags Properties
   * @name GetPropertyAddress
   * @summary Get Property Address
   * @request GET:/api/properties/{property_id}/address
   * @secure
   */
  getPropertyAddress = (propertyId, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}/address`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create or update the address for a property.
   *
   * @tags Properties
   * @name SetPropertyAddress
   * @summary Set Property Address
   * @request PUT:/api/properties/{property_id}/address
   * @secure
   */
  setPropertyAddress = (propertyId, data, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}/address`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Autocomplete Address.
   *
   * @tags Properties
   * @name AutocompleteAddress
   * @summary Autocomplete Address
   * @request GET:/api/properties/address/autocomplete
   * @secure
   */
  autocompleteAddress = (query, params = {}) =>
    this.http.request({
      path: `/api/properties/address/autocomplete`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get Place Details.
   *
   * @tags Properties
   * @name GetPlaceDetails
   * @summary Get Place Details
   * @request GET:/api/properties/address/place-details
   * @secure
   */
  getPlaceDetails = (query, params = {}) =>
    this.http.request({
      path: `/api/properties/address/place-details`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Geocode Address.
   *
   * @tags Properties
   * @name GeocodeAddress
   * @summary Geocode Address
   * @request GET:/api/properties/address/geocode
   * @secure
   */
  geocodeAddress = (query, params = {}) =>
    this.http.request({
      path: `/api/properties/address/geocode`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve photos for a property.
   *
   * @tags Properties
   * @name ListPhotos
   * @summary List Property Photos
   * @request GET:/api/properties/{property_id}/photos
   * @secure
   */
  listPhotos = (propertyId, query, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}/photos`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Add a photo to a property.
   *
   * @tags Properties
   * @name AddPhoto
   * @summary Add Property Photo
   * @request POST:/api/properties/{property_id}/photos
   * @secure
   */
  addPhoto = (propertyId, data, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}/photos`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Upload a raw image binary, automatically generate thumbnail (400x300) and Open Graph (1200x630) variants, and persist the photo record.
   *
   * @tags Properties
   * @name UploadPhoto
   * @summary Upload and Process Property Photo
   * @request POST:/api/properties/{property_id}/photos/upload
   * @secure
   */
  uploadPhoto = (propertyId, data, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}/photos/upload`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description Bulk reorder property photos.
   *
   * @tags Properties
   * @name ReorderPhotos
   * @summary Reorder Property Photos
   * @request PUT:/api/properties/{property_id}/photos/reorder
   * @secure
   */
  reorderPhotos = (propertyId, data, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}/photos/reorder`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update metadata for a property photo.
   *
   * @tags Properties
   * @name UpdatePhoto
   * @summary Update Property Photo
   * @request PUT:/api/properties/{property_id}/photos/{photo_id}
   * @secure
   */
  updatePhoto = (propertyId, photoId, data, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}/photos/${photoId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Remove a photo from a property.
   *
   * @tags Properties
   * @name DeletePhoto
   * @summary Delete Property Photo
   * @request DELETE:/api/properties/{property_id}/photos/{photo_id}
   * @secure
   */
  deletePhoto = (propertyId, photoId, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}/photos/${photoId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Retrieve amenities for a property.
   *
   * @tags Properties
   * @name ListAmenities
   * @summary List Property Amenities
   * @request GET:/api/properties/{property_id}/amenities
   * @secure
   */
  listAmenities = (propertyId, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}/amenities`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Add an amenity to a property.
   *
   * @tags Properties
   * @name AddAmenity
   * @summary Add Property Amenity
   * @request POST:/api/properties/{property_id}/amenities
   * @secure
   */
  addAmenity = (propertyId, data, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}/amenities`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Remove an amenity from a property.
   *
   * @tags Properties
   * @name DeleteAmenity
   * @summary Delete Property Amenity
   * @request DELETE:/api/properties/{property_id}/amenities/{amenity_id}
   * @secure
   */
  deleteAmenity = (propertyId, amenityId, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}/amenities/${amenityId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Retrieve utilities associated with a property.
   *
   * @tags Properties
   * @name ListUtilities
   * @summary List Property Utilities
   * @request GET:/api/properties/{property_id}/utilities
   * @secure
   */
  listUtilities = (propertyId, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}/utilities`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Add a utility entry to a property.
   *
   * @tags Properties
   * @name AddUtility
   * @summary Add Property Utility
   * @request POST:/api/properties/{property_id}/utilities
   * @secure
   */
  addUtility = (propertyId, data, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}/utilities`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update a property utility.
   *
   * @tags Properties
   * @name UpdateUtility
   * @summary Update Property Utility
   * @request PUT:/api/properties/{property_id}/utilities/{utility_id}
   * @secure
   */
  updateUtility = (propertyId, utilityId, data, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}/utilities/${utilityId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a property utility together with its payment records.
   *
   * @tags Properties
   * @name DeleteUtility
   * @summary Delete Property Utility
   * @request DELETE:/api/properties/{property_id}/utilities/{utility_id}
   * @secure
   */
  deleteUtility = (propertyId, utilityId, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}/utilities/${utilityId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Retrieve payment history for a property utility.
   *
   * @tags Properties
   * @name ListUtilityPayments
   * @summary List Utility Payments
   * @request GET:/api/properties/{property_id}/utilities/{utility_id}/payments
   * @secure
   */
  listUtilityPayments = (propertyId, utilityId, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}/utilities/${utilityId}/payments`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Record a utility payment for a property.
   *
   * @tags Properties
   * @name RecordUtilityPayment
   * @summary Record Utility Payment
   * @request POST:/api/properties/{property_id}/utilities/{utility_id}/payments
   * @secure
   */
  recordUtilityPayment = (propertyId, utilityId, data, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}/utilities/${utilityId}/payments`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve pricing history for a property.
   *
   * @tags Properties
   * @name ListPricing
   * @summary List Property Pricing
   * @request GET:/api/properties/{property_id}/pricing
   * @secure
   */
  listPricing = (propertyId, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}/pricing`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Add a pricing entry to a property.
   *
   * @tags Properties
   * @name AddPricing
   * @summary Add Property Pricing
   * @request POST:/api/properties/{property_id}/pricing
   * @secure
   */
  addPricing = (propertyId, data, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}/pricing`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Properties
   * @name ListPropertyAreas
   * @summary List property areas
   * @request GET:/api/properties/{property_id}/areas
   * @secure
   */
  listPropertyAreas = (propertyId, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}/areas`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Properties
   * @name CreatePropertyArea
   * @summary Create a property area
   * @request POST:/api/properties/{property_id}/areas
   * @secure
   */
  createPropertyArea = (propertyId, data, params = {}) =>
    this.http.request({
      path: `/api/properties/${propertyId}/areas`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Properties
   * @name UpdatePropertyArea
   * @summary Update a property area
   * @request PUT:/api/properties/areas/{area_id}
   * @secure
   */
  updatePropertyArea = (areaId, data, params = {}) =>
    this.http.request({
      path: `/api/properties/areas/${areaId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Properties
   * @name DeletePropertyArea
   * @summary Delete a property area
   * @request DELETE:/api/properties/areas/{area_id}
   * @secure
   */
  deletePropertyArea = (areaId, params = {}) =>
    this.http.request({
      path: `/api/properties/areas/${areaId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Properties
   * @name RegisterSmartLock
   * @summary Register Smart Lock or Electronic Lockbox
   * @request POST:/api/properties/{id}/smart-locks
   * @secure
   */
  registerSmartLock = (id, data, params = {}) =>
    this.http.request({
      path: `/api/properties/${id}/smart-locks`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Properties
   * @name ListSmartLocks
   * @summary List Smart Locks for Property
   * @request GET:/api/properties/{id}/smart-locks
   * @secure
   */
  listSmartLocks = (id, params = {}) =>
    this.http.request({
      path: `/api/properties/${id}/smart-locks`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Properties
   * @name GetSmartLock
   * @summary Get Smart Lock Details
   * @request GET:/api/properties/{id}/smart-locks/{lock_id}
   * @secure
   */
  getSmartLock = (id, lockId, params = {}) =>
    this.http.request({
      path: `/api/properties/${id}/smart-locks/${lockId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Properties
   * @name UpdateSmartLock
   * @summary Update Smart Lock Details
   * @request PATCH:/api/properties/{id}/smart-locks/{lock_id}
   * @secure
   */
  updateSmartLock = (id, lockId, data, params = {}) =>
    this.http.request({
      path: `/api/properties/${id}/smart-locks/${lockId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Properties
   * @name DeleteSmartLock
   * @summary Delete Smart Lock
   * @request DELETE:/api/properties/{id}/smart-locks/{lock_id}
   * @secure
   */
  deleteSmartLock = (id, lockId, params = {}) =>
    this.http.request({
      path: `/api/properties/${id}/smart-locks/${lockId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Properties
   * @name GenerateLockCode
   * @summary Generate Dynamic Access PIN
   * @request POST:/api/properties/{id}/smart-locks/{lock_id}/generate-code
   * @secure
   */
  generateLockCode = (id, lockId, params = {}) =>
    this.http.request({
      path: `/api/properties/${id}/smart-locks/${lockId}/generate-code`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
}
